import React from "react";
import { Outlet, Link, useLocation } from "react-router-dom";
import useUserData from "../hooks/useUserData";
import AuthModal from "./AuthModal";
import { useEffect } from "react";
import { getDoc, doc } from "firebase/firestore";
import { db } from "./firebase";
import "./css/CustomLook.css";

const StarSonataLayout = () => {
    const { userData, loading } = useUserData();
    const location = useLocation();

    useEffect(() => {
        const style = document.createElement("style");
        style.innerHTML = `
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `;
        document.head.appendChild(style);
      
        return () => {
          document.head.removeChild(style); // clean up if unmounted
        };
      }, []);

    useEffect(() => {
        if (!userData || userData.verified) return;
    
        const interval = setInterval(async () => {
          try {
            const snap = await getDoc(doc(db, "users", userData.uid));
            if (snap.exists() && snap.data().verified === true) {
              window.location.reload();
            }
          } catch (err) {
            console.error("Polling error:", err);
          }
        }, 5000);
    
        return () => clearInterval(interval);
      }, [userData]);

    const isLeader = userData?.role === "leader";
    const isVerified = userData?.verified;

    if (loading) {

           return <div style={{ textAlign: 'center', padding: '2rem' }}>
            <div style = {styles.spinner}></div></div>;
         }
      
         if (!userData) {
           return (
             <div style={{ color: "white", textAlign: "center", padding: "2rem" }}>
               <h1>Welcome</h1>
               <p>Please sign in or create an account to access your team dashboard.</p>
               <AuthModal onClose={() => window.location.reload()} />
             </div>
           );
         }


    if (userData && !userData.verified) {
        return (
          <div style={{ color: "white", textAlign: "center", padding: "2rem" }}>
            <h1>Hi {userData.username}</h1>
            <div style={styles.spinner}></div>
            <p>
              You're currently awaiting approval to join{" "}
              <strong>{userData.teamName || "a team"}</strong>.
            </p>            
            <p>
              Once your team leader approves your request, you'll gain access to the team dashboard.
            </p>
          </div>
          
        );
      }

    return (
        <div>
            <div style={{ color: "var(--theme-text-color)" }}>               

                <div style={styles.content}>
                    <Outlet />
                </div>
            </div>
        </div>
    );
};

const styles = {
    nav: {
        backgroundColor: "var(--theme-color)",        
        padding: "1rem",
        display: "flex",
        justifyContent: "center",
        gap: "2rem",
        borderBottom: "2px solid #444",
    },
    content: {
        padding: "2rem",
    },
    spinner: {
        margin: "20px auto",
        border: "4px solid #ccc",
        borderTop: "4px solidrgb(125, 0, 0)",
        borderRadius: "50%",
        width: "40px",
        height: "40px",
        animation: "spin 1s linear infinite",
      },
};

const getLinkStyle = (isActive) => ({
    color: "#fff",
    textDecoration: "none",
    fontWeight: isActive ? "bold" : "normal",
    borderBottom: isActive ? "2px solid #fff" : "none",
});



export default StarSonataLayout;
